
import { useEffect, useRef, useState } from "react";

import { Card } from "primereact/card";
import { InputMask } from "primereact/inputmask";
import { Toast } from "primereact/toast";

import Tree from "react-d3-tree";

import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu";

import "./styles.css";

import spi from "../../../services/spi";

export default function MapaRolada() {
    const [data, setData] = useState({});
    const [input, setInput] = useState("");
    const [width, setWidth] = useState(0);

    const [isLoading, setIsLoading] = useState(false);

    const toast = useRef();

    const handleSearch = _ => {
        if (input.length === 6) {
            setIsLoading(true);
            spi.get("", {
                params: {
                    "rolada": input
                }
            }).then((response) => {
                setIsLoading(false);
                const data = response.data;

                let object = {
                    name: data.rolada,
                    children: [],
                }

                let array = [];

                data.RoloUrdumeList.forEach((item) => {
                    let object1 = {
                        name: item.rolo,
                        attributes: {
                            metragem: item.metros,
                        },
                        children: []
                    }

                    item.RoloArtigoList.forEach((item2) => {
                        let object2 = {
                            name: item2.nomerolo,
                            attributes: {
                                metragem: item2.metros,
                            },
                            children: []
                        }

                        item2.RoloPecaList.forEach((item3) => {
                            let object3 = {
                                name: item3.nrolo,
                                attributes: {
                                    metragem: item3.metros,
                                },
                                children: []
                            }

                            object2.children.push(object3);
                        })

                        object1.children.push(object2);
                    });

                    array.push(object1);
                });

                object.children = array;
                setData(object);
            }).catch((error) => {
                setIsLoading(false);
            });
        } else {
            toast.current.show({ detail: "Preencha a rolada corretamente", severity: "warn", summary: "Atenção" });
            return;
        }
    }

    useEffect(() => {
        let size = window.screen.availWidth;
        setWidth(size / 2);
    }, []);

    if(isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Rolada"
                subTitle=""
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <InputMask
                        mask="99-999"
                        onBlur={handleSearch}
                        onChange={e => setInput(e.target.value)}
                        value={input}
                    />
                </div>
                <div id="treeWrapper" className="p-d-flex p-flex-row p-jc-center p-ai-center" style={{ height: "78vh"}} >
                    <Tree 
                        collapsible={true}
                        data={data} 
                        translate={{ x: width, y: 60 }}
                        orientation="vertical"          
                        rootNodeClassName="node__root"
                        branchNodeClassName="node__branch"
                        leafNodeClassName="node__leaf"
                    />
                </div>
            </Card>
        </div>
    )
}